/* eslint-disable react/prop-types */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/no-import-module-exports */
import React from 'react';

import { View } from 'react-native-web';

const SafeAreaView = React.forwardRef((props, ref) => (
    React.createElement(View, { ...props, ref })
));
const SafeAreaProvider = ({ children }) => React.createElement(View, null, children);

const useSafeAreaInsets = () => ({
    top: 0, right: 0, bottom: 0, left: 0,
});

// ts-prune-ignore-next
export {
    SafeAreaView,
    SafeAreaProvider,
    useSafeAreaInsets,
};

const api = {
    SafeAreaView,
    SafeAreaProvider,
    useSafeAreaInsets,
    initialWindowMetrics: undefined,
};

// ts-prune-ignore-next
export default api;
